import React, { Component } from "react";

export default class Nofound extends Component {
  state = {};
  render() {
    return (
      <div>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Schedule Maintenance</title>
        {/* <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
          rel="stylesheet"
        /> */}
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n        body{\n margin: 0px;\nbackground:#8b7df2\n        }\n        @media screen and (max-width: 600px) {\n            .important {\n                width: 310px !important;\n                padding: 20px !important;\n            }\n        }\n    ",
          }}
        />
        <div
          classname="login-container"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            textAlign: "center",
            height: window.innerWidth > 767 ? 200 : 240,
            width: window.innerWidth > 767 ? 850 : 360,
            padding: window.innerWidth > 767 ? 30 : 15,
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: 10,
            backgroundColor: "#fff",
          }}
        >
          <div>
            <img
              src="https://elite-logos.s3.ap-south-1.amazonaws.com/Elite_Logo_White_BG.jpg"
              alt=""
              height="70px"
            />
            <p
              style={{
                fontFamily: "Roboto",
                lineHeight: 1.5,
                fontSize: 22,
                fontWeight: 500,
                color: "#242326",
              }}
            >
              Oops! Looks like the page you are trying to access doesn't exist.
              <br /> To login to your elite account,{" "}
              <a
                style={{ textDecoration: "none", color: "#8b7df2" }}
                href="https://app.elitelearning.io/user-login"
              >
                click here
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
